export default __webpack_public_path__ + "static/featuredImage-344f95b85c3f4f1c8092fe129006222b.webp";